import { observable as realObservable } from "s2-engine";

import { IS_NODE_BROWSERLESS } from "@/__main__/constants.mjs";

// Neuter this functionality on the server.
export const observable = IS_NODE_BROWSERLESS ? (id) => id : realObservable;
